export const API_BASE_URL = (
  process.env.REACT_APP_API_BASE_URL || "http://127.0.0.1:8000"
).replace(/\/+$/, "");

export const ENDPOINTS = {
  auth: "/token/",
  refresh: "/token/refresh/",
  profile: "/iam/users/me/",
} as const;
